<template>
  <bootstrap-modal
    :modal-title="modalTitle"
    :is-open="isModalOpen"
    :canSubmit="canSubmit"
    size="lg"
    @modal:close="closeStudentEnrollmentModal"
    @modal:okay="submitStudentEnrollment"
  >
    <div class="col">
      <form>
        <div class="alert alert-warning" role="alert">
          導師所屬群組名單：{{ this.groupList }}
          <br>
          導師群組報名場次上限： {{ this.appointment.counselor_group_limit }}
        </div>
        <form-row>
          <form-group
            cols="4"
            label="職涯諮詢師"
          >
            <input-group>
              <form-input
                v-model="appointment.counselor_name"
                name="counselor_name"
                readonly
              />
            </input-group>
          </form-group>
          <form-group
            cols="4"
            label="日期"
          >
            <input-group>
              <form-input
                v-model="appointment.appointment_time_slot.appointment_date"
                name="appointment_date"
                readonly
              />
            </input-group>
          </form-group>
          <form-group
            cols="4"
            label="時段"
          >
            <input-group>
              <form-input
                v-model="appointment.time_slot_formated"
                name="appointment_time_slot"
                readonly
              />
            </input-group>
          </form-group>
        </form-row>
        <form-row>
          <form-group
            cols="12"
            label="諮詢項目:"
          >
            <input-group>
              <form-input
                v-model="servicesJoint"
                name="appointment_services"
                readonly
              />
            </input-group>
          </form-group>
        </form-row>
        <form-section-divider />
        <form-row>
          <form-group
            cols="3"
            label="學號"
          >
            <input-group>
              <form-input
                v-model="currentStudentGetter.student_id"
                name="student_id"
                placeholder="M123456789"
                readonly
              />
            </input-group>
          </form-group>
          <form-group
            cols="3"
            label="姓名"
          >
            <input-group>
              <form-input
                v-model="currentStudentGetter.student_name"
                name="student_name"
                id="studentNameField"
                required
              />
            </input-group>
          </form-group>
          <form-group cols="3" label="性別">
            <input-group>
              <form-select :default-value="currentStudentGetter.student_sex" :options="[{
                  name: '男',
                  value: 1,
                }, {
                  name: '女',
                  value: 0,
                }]" id="genderField" name="sex" @change="sexSelected" required/>
            </input-group>
          </form-group>
          <form-group
            cols="3"
            label="系所"
          >
            <input-group>
              <form-input
                v-model.trim="studentDepartment"
                name="student_name"
                readonly
              />
            </input-group>
          </form-group>
        </form-row>
        <form-row>
          <form-group
            cols="6"
            label="E-mail"
          >
            <input-group>
              <template slot="append">
                <span
                  aria-hidden="true"
                  class="input-group-text text-muted btn-pill"
                >
                  ＠mail.ntust.edu.tw
                </span>
              </template>
              <form-input
                v-model="currentStudentGetter.student_id"
                name="student_id"
                readonly
              />
            </input-group>
          </form-group>
          <form-group
            cols="6"
            label="備用電子信箱"
          >
            <input-group>
              <form-input
                v-model="enrollment.student_alternate_email"
                name="student_alternate_email"
              />
            </input-group>
          </form-group>
        </form-row>
        <form-row>
          <form-group
            cols="6"
            label="電話"
          >
            <input-group>
              <form-input
                v-model="currentStudentGetter.student_phone_number"
                name="student_phone_number"
                id="studentPhoneNumber"
                required
              />
            </input-group>
          </form-group>
          <form-group
            cols="6"
            label="備用電話"
          >
            <input-group>
              <form-input
                v-model="enrollment.student_alternate_phone_number"
                name="student_alternate_phone_number"
              />
            </input-group>
          </form-group>
        </form-row>
      </form>
    </div>

    <template slot="footer">
      <!-- <form-section-divider v-show="showPrivacyPolicy" /> -->
      <form-row class="flex-fill">
        <div class="col">
          <div v-if="showPrivacyPolicy" class="form-check">
            <check-input class="m-auto" label="同意" name="agree-privacy-policy" @change="isAgreePrivacyPolicy">
              <template slot="label">
                <button-wrapper thickness="xs" @click.prevent="openPolicyWindow">
                  {{ type == 'Career Counselling' ? "職涯諮詢同意書" : "業師諮詢同意書" }}
                </button-wrapper>
              </template>
            </check-input>
          </div>
        </div>
      </form-row>
    </template>
  </bootstrap-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import BootstrapModal from '~bootstrap/Modal'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import ButtonWrapper from '~components/common/buttons'
import CheckInput from '~components/common/form/input/Check'
import InputGroup from '~components/common/form/input/Group'
import FormSelect from '~components/common/form/Select'
import DatePicker from '~components/third-party/larvata/DatePicker'
import FormSectionDivider from '~components/common/form/section/Divider'
export default {
  name: 'StudentEnrollCounsellingModal',
  components: {
    BootstrapModal,
    FormRow,
    FormGroup,
    FormInput,
    InputGroup,
    DatePicker,
    FormSectionDivider,
    ButtonWrapper,
    FormSelect,
    CheckInput
  },
  props: {
    isModalOpen: Boolean,
    modalTitle: {
      type: String,
      required: true
    },
    appointment: {
      type: Object,
      default: () => {}
    },
    groupList: {
      type: String,
      default: ''
    },
    showPrivacyPolicy: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "Career Counselling"
    }
  },
  data () {
    return {
      enrollment: {
        student_alternate_email: '',
        sex: 1
      },
      canSubmit: !this.showPrivacyPolicy,
      type: this.type
    }
  },
  computed: {
    ...mapGetters('pages/students', [
      'currentStudentGetter',
      'getStudentDepartmentById',
      'getAcademicDegreeByCode'
    ]),
    ...mapGetters('pages/career-counselling', [
      'servicesGetter'
    ]),
    servicesJoint () {
      const services = this.appointment.appointment_services.map(service => {
        const checkedService = this.servicesGetter.find(serv => service === serv.counselling_service_id)
        return checkedService.counselling_service_name
      })
      return services.join('、')
    },
    studentDepartment () {
      if (!Object.keys(this.currentStudentGetter).length) {
        return ''
      }
      return `${this.getAcademicDegreeByCode(this.currentStudentGetter.student_academic_degree)}/${this.getStudentDepartmentById(this.currentStudentGetter.student_department).department_name}/${this.currentStudentGetter.student_grade}年級`
    }
  },
  created () {

    this.enrollment.student_name = this.currentStudentGetter.student_name;
    this.enrollment.student_tel = this.currentStudentGetter.student_phone_number;
    this.enrollment.student_alternate_email = this.currentStudentGetter.student_alt_email;
    this.enrollment.sex = this.currentStudentGetter.student_sex;
    this.enrollment.foods = this.currentStudentGetter.student_foods;
    
  },
  methods: {
    sexSelected(e) {
      this.enrollment.sex = e.value
    },
    foodsSelected(e) {
      this.enrollment.foods = e.value
    },
    closeStudentEnrollmentModal () {
      this.$emit('modal:close')
    },
    submitStudentEnrollment () {
      if (this.canSubmit) {

        let nameField = document.getElementById("studentNameField");
        let telField = document.getElementById("studentPhoneNumber");

        // 姓名驗證: 只能包含 中文、英文、空格、- 及 () [] {}
        let nameRegex = /^[\u4e00-\u9fa5A-Za-z\s\-\(\)\[\]\{\}]+$/;
        if (this.enrollment.student_name === "") {
            nameField.setCustomValidity("姓名欄位不能為空");
            nameField.reportValidity();
            return;
        } else if (!nameRegex.test(this.enrollment.student_name)) {
            nameField.setCustomValidity("姓名只能包含中文、英文、空格、- 及括號");
            nameField.reportValidity();
            return;
        } 
      
        let telRegex = /^[\d+\-()]+$/;
        if (this.enrollment.student_tel === "") {
            telField.setCustomValidity("電話欄位不能為空");
            telField.reportValidity();
            return;
        } else if (!telRegex.test(this.enrollment.student_tel)) {
            telField.setCustomValidity("請輸入有效的電話號碼");
            telField.reportValidity();
            return;
        }


        if(this.enrollment.sex === "") {

          document.getElementById("genderField").setCustomValidity("此欄位不能爲空");
          document.getElementById("genderField").reportValidity();
          return;
        }
        this.$emit('modal:close')
        this.$emit('submit', { ...this.enrollment, ...this.appointment })
      }
    },
    openPolicyWindow () {

      const target = this.$router.resolve(this.type == 'Career Counselling' ? '/consent/career':'/consent/workplace')
      window.open(target.href, '_blank')
    },
    birthdaySelected (date) {
      this.enrollment = Object.assign({}, this.enrollment, {
        student_birthday: date.startDate
      })
    },
    isAgreePrivacyPolicy (value) {
      this.canSubmit = value
    }
  }
}
</script>
